import type { FC } from 'react';
import React from 'react';

import type { TCircle } from './models';

export const Circle: FC<TCircle> = ({
    centerX,
    centerY,
    height,
    numberPath,
    progressPath,
    radius,
    width,
}) => {
    return (
        <svg
            fill="none"
            height={height}
            viewBox={`0 0 ${width} ${height}`}
            width={width}
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clipPath="url(#clip0)">
                <g clipPath="url(#clip1)">
                    {/* Фоновый круг с серой пунктирной обводкой */}
                    <circle
                        cx={centerX}
                        cy={centerY}
                        fill="none"
                        r={radius}
                        stroke="#D5D6DC"
                        strokeDasharray="2 4"
                        strokeLinecap="round"
                        strokeWidth={2}
                    />
                    {/* Прогресс-дуга */}
                    <path
                        d={progressPath}
                        fill="none"
                        id="progressPath"
                        stroke="#EF3124"
                        strokeLinecap="round"
                        strokeWidth={2}
                    />
                    <path
                        d={numberPath}
                        fill="#030306"
                        fillOpacity="0.88"
                        xmlns="http://www.w3.org/2000/svg"
                    />
                </g>
            </g>
            <defs>
                <clipPath id="clip0">
                    <rect fill="white" height={height} width={width} />
                </clipPath>
                <clipPath id="clip1">
                    <rect fill="white" height={height} width={width} />
                </clipPath>
            </defs>
        </svg>
    );
};
